import React, { useEffect } from "react";
import OfferGrid from "../components/OfferGrid";
import PageMeta from "../components/PageMeta";
import RevealOnScroll from "../components/RevealOnScroll";
import HomeClientTypes from "../components/home/HomeClientTypes";
import HomeFinalCta from "../components/home/HomeFinalCta";
import HomeHero from "../components/home/HomeHero";
import HomeHowItWorks from "../components/home/HomeHowItWorks";
import HomeSecurity from "../components/home/HomeSecurity";
import HomeTrustBar from "../components/home/HomeTrustBar";
import HomeManagedContent from "../components/home/HomeManagedContent";
import MobileMoneyNetworks from "../components/home/MobileMoneyNetworks";
import TrustedPartners from "../components/home/TrustedPartners";
import { useLanguage } from "../i18n/LanguageProvider";

const Home = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ws-page ws-home" data-no-i18n="true">
      <PageMeta
        title="WonyaSoft | Solutions numériques de paiement en RDC"
        description="WonyaSoft développe WonyaPay, BulkPay, une application mobile de paiement, des API de paiement et des solutions monétiques adaptées aux entreprises et institutions."
      />

      <HomeHero />
      <HomeTrustBar />
      <MobileMoneyNetworks />

      <TrustedPartners />

      <section
        className="ws-section ws-home-solutions"
        aria-labelledby="ws-offers-title"
      >
        <div className="ws-shell">
          <RevealOnScroll className="ws-section-heading">
            <span className="ws-kicker">
              {t("Nos solutions numériques de paiement")}
            </span>
            <h2 id="ws-offers-title">
              {t("Un écosystème, trois façons d’avancer")}
            </h2>
            <p>
              {t(
                "De l’intégration API à l’encaissement mobile, choisissez le parcours adapté à votre organisation.",
              )}
            </p>
          </RevealOnScroll>
          <OfferGrid animated />
        </div>
      </section>

      <HomeManagedContent section="blog" />
      <HomeHowItWorks />
      <HomeClientTypes />
      <HomeManagedContent section="testimonials" />
      <HomeSecurity />
      <HomeFinalCta />
    </div>
  );
};

export default Home;
